import { put } from 'redux-saga/effects'
import { fetchAdmin, fetchAdminFailed, fetchAdminSuccess } from '../actions'
import { getEnterpriseAdmin } from '../../../utils/api'

export function* getAdminHandler() {
  try {
    fetchAdmin()
    const res = yield getEnterpriseAdmin()
    yield put(fetchAdminSuccess(res.data))
  } catch (error) {
    yield put(fetchAdminFailed(error))
  }
}
